import React, { useState, useEffect, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { toastr } from '@/utils/toast'
import _ from 'lodash'

import config from '@/config/config-esm'

import { setDepartment } from '@/store/slices/layoutSlice'
import { setFormData } from '@/store/slices/formDataSlice'

const PickDepartment = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const anon = useSelector((state) => state.anon)
  
  const [departmentId, setDepartmentId] = useState('')
  const [subDepartments, setSubDepartments] = useState([])

  useEffect(() => {
    // get sub departments
    if (user.departments && user.departments.length > 0) {
      setDepartmentId(user.departments[0].id)

      _.forEach(user.departments, (department) => {
        axios
          .get(`${config.apiUrl}/departments/${department.id}/departments`)
          .then((r) => {
            setSubDepartments(prevSubDepartments => [...prevSubDepartments, ...r.data])
          })
          .catch((e) => {
            console.error('error: ', e)
          })
      })
    }
  }, [user.departments])

  const chooseDepartment = (e) => {
    e.preventDefault()
    dispatch(setFormData({ departmentId: departmentId }))
    dispatch(setDepartment(departmentId))
  }

  return (
    <form onSubmit={(e) => chooseDepartment(e)}>
      <div className="input_wrapper">
        <select
          onChange={(e) => setDepartmentId(e.target.value)}
          value={departmentId}
        >
          {user &&
            user.departments &&
            user.departments.map((department) => (
              <React.Fragment key={`parent-${department.id}`}>
                <option value={department.id}>{department.name}</option>
                {subDepartments.map((subDepartment) => (
                  <option value={subDepartment.id} key={`child-${subDepartment.id}`}>
                    -- {subDepartment.name}
                  </option>
                ))}
              </React.Fragment>
            ))}
        </select>
      </div>
      <button>Velg avdeling</button>
    </form>
  )
}

export default PickDepartment
